import { Controller } from "@hotwired/stimulus";
import { track } from "../analytics";

export default class extends Controller {
  trackBookCall(event) {
    const location = event.target.dataset.location || "hero";

    track("cta_book_call_clicked", {
      location: location,
    });
  }

  trackViewWork(event) {
    track("cta_view_work_clicked");
  }
}
